import { CreateShopTemplate } from "@/components/Templates";
import { useCreateShopPage } from "@/hooks/useCreateShopPage";

export function CreateShopPage() {
  const createShop = useCreateShopPage();

  return <CreateShopTemplate {...createShop} />;
}
